import { makeStyles } from 'tss-react/mui';

const drawerWidth = 240;

const useStyles = makeStyles()((theme) => ({
  toolbar: {
    height: '80px',
    // width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '240px',
    backgroundColor: '#FF1616',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      flexWrap: 'wrap',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
  linkButton: {
    '&:hover': {
      color: 'white !important',
      textDecoration: 'none',
    },
  },
}));

export default useStyles;
